type TruncateTextProps = {
	text: string;
	containerWidth: number;
	targetWidth: number;
	txtWidth: number;
	shrinkFactor?: number;
};

export const truncateText = ({
	text,
	containerWidth,
	targetWidth,
	txtWidth,
	shrinkFactor = 1,
}: TruncateTextProps): string => {
	if (text.length > 20 && targetWidth > containerWidth) {
		const totalChars = text.length;
		const averageCharWidth = txtWidth / totalChars;
		const visibleChars =
			(containerWidth - (targetWidth - txtWidth)) / (averageCharWidth * shrinkFactor);
		const charsToRemoveEachSide = (totalChars - visibleChars + 5) / 2;
		const leftEndIndex = Math.floor(totalChars / 2 - charsToRemoveEachSide);
		const rightStartIndex = Math.ceil(totalChars / 2 + charsToRemoveEachSide);

		return `${text.substring(0, leftEndIndex)}...${text.substring(rightStartIndex)}`;
	}
	return text;
};
